"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgentName = void 0;
var AgentName;
(function (AgentName) {
    AgentName["CrossSell"] = "CROSS_SELL";
    AgentName["PurchaseRecurrence"] = "PURCHASE_RECURRENCE";
})(AgentName || (exports.AgentName = AgentName = {}));
//# sourceMappingURL=agent.js.map